import { cva } from 'class-variance-authority'

export interface HeaderProps {
  narrow?: boolean
  scrollable?: boolean
}

export const headerVariants = {
  base: cva('py-s lg:py-s sticky top-0 ease-in-out transition-transform duration-200 z-50 bg-inherit dark:bg-[--background] text-[--text] [--ks-surface:var(--background)]', {
    variants: {
      theme: {
        blurple: '[--background:theme(colors.blurple.100)] [--text:theme(colors.primary)] [--ks-text:var(--text)] [--divider:theme(colors.blurple.300)]',
        moss: '[--background:theme(colors.moss.500)] dark:[--text:theme(colors.moss.200)] [--text:theme(colors.moss.500)] [--ks-text:theme(colors.moss.200)] [--divider:theme(colors.moss.100)]',
        carbon: '[--background:theme(colors.carbon.50)] dark:[--background:theme(colors.carbon.500)] [--text:theme(colors.primary)] dark:[--text:theme(colors.carbon.50)] [--ks-text:var(--text)] [--divider:theme(colors.carbon.200)] dark:[--divider:theme(colors.carbon.400)]',
      },
      scrolled: {
        true: 'shadow-sm',
        false: 'shadow-none',
      },
    },
  }),

  button: cva('cursor-pointer no-underline text-small py-xs px-xs flex items-center rounded-lg outline outline-2 outline-transparent focus-visible:outline-blurple-300 hover:bg-[--active-bg] focus-visible:bg-[--active-bg] active:bg-[--active-bg] gap-2xs', {
    variants: {
      theme: {
        blurple: '[--active-bg:theme(colors.blurple.50)]',
        moss: '[--active-bg:theme(colors.moss.200)] focus-visible:outline-moss-300 dark:[--active-bg:theme(colors.moss.400)] dark:focus-visible:outline-blurple-300',
        carbon: '[--active-bg:theme(colors.carbon.100)] dark:[--active-bg:theme(colors.carbon.400)] dark:text-carbon-50',
      },
      active: {
        true: 'bg-[--active-bg]',
        false: 'bg-transparent',
      },
      badge: {
        true: 'pl-5',
        false: '',
      },
    },
    compoundVariants: [
      {
        theme: 'carbon',
        active: true,
        class: 'bg-carbon-50 dark:text-carbon-50',
      },
    ],
  }),
}
